module.exports = __webpack_public_path__ + "img/logo.647cf343.png";